export default __webpack_public_path__ + "static/media/T5WInfographics2.21f5c7168f8bb8047af81ab5b785153b.png";